import { render, staticRenderFns } from "./ViewAdmissionFormFullData.vue?vue&type=template&id=6c5e27df&scoped=true"
import script from "./ViewAdmissionFormFullData.vue?vue&type=script&lang=js"
export * from "./ViewAdmissionFormFullData.vue?vue&type=script&lang=js"
import style0 from "./ViewAdmissionFormFullData.vue?vue&type=style&index=0&id=6c5e27df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e27df",
  null
  
)

export default component.exports